module.exports = __webpack_public_path__ + "img/1440.3026b737.jpg";